module.exports = __webpack_public_path__ + "media/images/contact_applications-323acdc3.png";